<template>
    <div class="ModalSearchPartsComponent">
        
        <b-modal class="modal-xxx" v-model="isModalSearchPartsComponent" no-close-on-esc no-close-on-backdrop :title="modalTitle"
            :header-bg-variant="theme.headerBgVariant" :header-text-variant="theme.headerTextVariant"
            :body-bg-variant="theme.bodyBgVariant" :body-text-variant="theme.bodyTextVariant"
            :footer-bg-variant="theme.footerBgVariant" :footer-text-variant="theme.footerTextVariant"
            :size="modalComponentObject.size" :hide-header-close="hideHeaderClose" scrollable>
            <br>
            
            <b-container v-if="modalComponentObject.type == 'bom'" class="bv-example-row" fluid>
                
                <b-row>
                    <b-col cols="2">
                        <TreeSearchPartsComponent :lang="modalComponentObject.lang.Tree" v-bind:class="usingTheme">
                    </TreeSearchPartsComponent>
                    </b-col>
                    <b-col cols="7">
                        <div class="modalPartTable">
                            <DataTableModalSearchPartsComponent 
                            :lang="modalComponentObject.lang.PartTable" 
                            v-bind:class="usingTheme"
                            source="modalSearchParts"
                            :data="modalComponentObject.data">
                            </DataTableModalSearchPartsComponent>
                            

                        </div>
                        
                    </b-col>
                    <b-col cols="3">
                        <span v-if="selectedSearchPartRows == null">
                            <p>{{ modalComponentObject.lang.infotext_1}}</p>
                        </span>
                        <span v-else>
                            <QuickViewTableComponent 
                            parent="modalSearchParts" 
                            :lang="modalComponentObject.lang.QuickView"
                            v-bind:class="usingTheme">
                            </QuickViewTableComponent>
                        </span>
                    </b-col>
                </b-row>
                
            </b-container>
            <br>

            <div slot="modal-footer" class="w-100">
                <span v-if="modalComponentObject.buttons == 2">

                    <b-btn size="sm" class="btn float-right" :variant="theme.btnVariant" @click="no"
                        v-on:keydown.enter="keydown">
                        Cancel
                    </b-btn>
                    <b-btn size="sm" class="btn float-right" :variant="theme.btnVariant" @click="yes"
                        v-on:keydown.enter="keydown">
                        OK
                    </b-btn>
                </span>
                <span v-if="modalComponentObject.buttons == 1">
                    <b-btn size="sm" class="btn float-right" :variant="theme.btnVariant" @click="Custom"
                        v-on:keydown.enter="keydown">
                        {{modalComponentObject.buttonName}}
                    </b-btn>

                </span>

            </div>
        </b-modal>
        
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TreeSearchPartsComponent from '@/components/shared/TreeSearchPartsComponent'
import DataTableModalSearchPartsComponent from '@/components/shared/DataTableModalSearchPartsComponent'
import QuickViewTableComponent from '@/components/shared/QuickViewTableComponent'

export default {
    name: 'ModalSearchPartsComponent',
    components: {
        TreeSearchPartsComponent,
        DataTableModalSearchPartsComponent,
        QuickViewTableComponent

    },
    props: {
        //lang: Object
    },
    data() {
        return {

            hideHeaderClose: true,
            

        }
    },
    computed: {
        ...mapGetters({
            selectedRows: 'selectedRows',
            //isPlugin: 'isPlugin'
        }),
        usingTheme() {
            return this.theme.modal
        },
        modalTitle() {


            if (this.modalComponentObject.lang == undefined) {
                return ""
            }

            return this.modalComponentObject.lang.modal_Title;
        },
        isModalSearchPartsComponent: {

            get() {
                return this.$store.getters.isModalSearchPartsComponent
            },
            set(value) {

                //this.$store.commit('SHOWALERT', false);
            },
        },
        selectedSearchPartRows() {
            return this.$store.getters.selectedSearchPartRows;
        },
        modalComponentObject() {

            let o = this.$store.getters.modalSearchPartsComponentObject;
            if (o.noCloseOnBackdrop == undefined) {
                o.noCloseOnBackdrop = false;
            }
            if (o.noCloseOnEsc == undefined) {
                o.noCloseOnEsc = false;
            }

            return o;
        },
        theme() {

            const obj = {};
            if (this.$store.getters.s_skinVariant == "light") {
                obj.headerBgVariant = 'light';
                obj.headerTextVariant = 'dark';
                obj.bodyBgVariant = 'white';
                obj.bodyTextVariant = 'dark';
                obj.footerBgVariant = 'light';
                obj.footerTextVariant = 'dark';
                obj.btnVariant = 'dark';
                obj.modal = '--lightModal';

            } else if (this.$store.getters.s_skinVariant == "dark") {
                obj.headerBgVariant = 'dark';
                obj.headerTextVariant = 'light';
                obj.bodyBgVariant = 'dark';
                obj.bodyTextVariant = 'light';
                obj.footerBgVariant = 'dark';
                obj.footerTextVariant = 'light';
                obj.btnVariant = 'light';
                obj.modal = '--darkModal';
            }
            return obj;
        },


    },
    created() {

    },
    watch: {
        isModalComponent: function (newVal, oldVal) {

            if (newVal == true) {

                let vue = this;

                setTimeout(function () {

                    let fade = document.getElementsByClassName("modal fade");
                    if (fade != null) {
                        fade[0].addEventListener("click", function (e) {

                            if (e.target.className == "modal fade show") {
                                //vue.$store.dispatch("hideModalSearchPartsComponent");
                            }
                        })
                    }


                }, 1000)

            }
        }
    },
    methods: {
        yes: function () {
            this.$store.dispatch("hideModalSearchPartsComponent");


            if (this.modalComponentObject.funcYes != "") {
                this.modalComponentObject.funcYes(this);
            }


        },
        no: function () {
            this.$store.dispatch("hideModalSearchPartsComponent");

        
            if (this.modalComponentObject.funcNo != "") {
                this.modalComponentObject.funcNo(this);
            }


        },
        Custom: function () {
            this.$store.dispatch("hideSearchPartsModalComponent");


          
            if (this.modalComponentObject.funcCustom != "") {
                this.modalComponentObject.funcCustom(this);
            }


        },
        keydown() {
            
        },
        deleteComponent: function () {
            
        }
    }
}
</script>
<style lang="scss">
@import "./../../scss/_modal.scss";


.ModalSearchPartsComponent {

    .modal-content {

        max-width: 1950px;
        margin: 1rem auto;
        
    }
        
    


}
</style>



// WEBPACK FOOTER //
// src/components/shared/ModalSearchPartsComponent.vue